import UAParser from 'ua-parser-js';
import { loadFile, loadForm, loadRecords } from './functions';

const GLOBALS = [
  'locale',
  'language',
  'timeZone',
  'decimalSeparator',
  'groupingSeparator',
  'currencySymbol',
  'currencyCode',
  'country',
  'deviceIdentifier',
  'deviceModel',
  'deviceManufacturer',
  'platform',
  'platformVersion',
  'application',
  'applicationVersion',
  'applicationBuild',
];

export default class ExpressionEngineGlobals {
  variables;
  ua;
  constructor() {
    this.parse();
    this.setup();
  }

  static GLOBALS() {
    return GLOBALS;
  }

  setup() {
    this.variables = {};

    for (const variableName of GLOBALS) {
      this.variables[variableName] = this.getOverride(variableName) || this[variableName]();
    }
  }

  getOverride(name) {
    // @ts-ignore
    if (window.ExpressionEngineOverrides && window.ExpressionEngineOverrides[name] != null) {
      // @ts-ignore
      return window.ExpressionEngineOverrides[name];
    }

    return null;
  }

  locale() {
    // nothing
  }

  language() {
    if (navigator.languages != null) {
      return navigator.languages[0];
    }
    // @ts-ignore
    return navigator.language || navigator.userLanguage;
  }

  timeZone() {
    if (typeof window.Intl !== 'undefined') {
      return new window.Intl.DateTimeFormat().resolvedOptions().timeZone;
    }

    // @ts-ignore
    if (typeof window.jstz !== 'undefined') {
      // @ts-ignore
      return window.jstz.determine().name();
    }

    return null;
  }

  decimalSeparator() {
    if (typeof window.Intl !== 'undefined') {
      return new window.Intl.NumberFormat().format(0.1)[1];
    }

    return '.';
  }

  groupingSeparator() {
    if (typeof window.Intl !== 'undefined') {
      return new window.Intl.NumberFormat().format(1000)[1];
    }

    return ',';
  }

  currencySymbol() {
    return null;
  }

  currencyCode() {
    return null;
  }

  country() {
    return null;
  }

  deviceIdentifier() {
    return null;
  }

  deviceModel() {
    return this.ua != null ? this.ua.device.model : null;
  }

  deviceManufacturer() {
    return this.ua != null ? this.ua.device.vendor : null;
  }

  platform() {
    return this.ua != null ? this.ua.os.name : null;
  }

  platformVersion() {
    return this.ua != null ? this.ua.os.version : null;
  }

  application() {
    return this.ua != null ? this.ua.browser.name : null;
  }

  applicationVersion() {
    return this.ua != null ? this.ua.browser.version : null;
  }

  applicationBuild() {
    return this.ua != null ? this.ua.engine.name : null;
  }

  parse() {
    this.ua = new UAParser().getResult();
  }

  httpRequest(engine, options, callbackID) {
    // this one is a little bit special because we want to actually perform the http
    // call from the iframe. This helps possible security issues with requests being made
    // from the Fulcrum App origin.
    engine.send('httpRequest', { options: JSON.parse(options) }, (message) => {
      engine.finishAsyncCallback(callbackID, message.result);
    });
  }

  setTimeout(engine, delay, callbackID) {
    setTimeout(() => {
      engine.finishAsyncCallback(callbackID, null);
    }, delay);
  }

  messageBox(engine, options, callbackID) {
    if (engine.delegate) {
      engine.delegate.showMessageBox(JSON.parse(options), (result) => {
        engine.finishAsyncCallback(callbackID, [result]);
      });
    }
  }

  inference(engine, options, callbackID) {
    window.Fulcrum.globals.organization.date_event_inference_enabled
      ? engine.finishAsyncCallback(callbackID, [{ message: 'INFERENCE() is not supported in the browser' }])
      : engine.finishAsyncCallback(callbackID, [{ message: 'The Data Event function INFERENCE() is not available for your current plan. Contact our sales team for more information.' }]);
  }

  loadFile(engine, options, callbackID) {
    window.Fulcrum.globals.organization.data_event_loadfile_enabled
      ? loadFile(engine.delegate.context.api, JSON.parse(options), (error, result) => {
        engine.finishAsyncCallback(callbackID, [error, result]);
      })
      : engine.finishAsyncCallback(callbackID, [{ message: 'The Data Event function LOADFILE() is not available for your current plan. Contact our sales team for more information.' }]);
  }

  loadRecords(engine, options, callbackID) {
    loadRecords(engine.delegate.context.api, JSON.parse(options), (error, result) => {
      engine.finishAsyncCallback(callbackID, [error, result]);
    });
  }

  loadForm(engine, options, callbackID) {
    loadForm(engine.delegate.context.api, JSON.parse(options), (error, result) => {
      engine.finishAsyncCallback(callbackID, [error, result]);
    });
  }

  recognizeText(engine, options, callbackID) {
    window.Fulcrum.globals.organization.data_event_recognizetext_enabled
      ? engine.finishAsyncCallback(callbackID, [{ message: 'RECOGNIZETEXT() is not supported in the browser' }])
      : engine.finishAsyncCallback(callbackID, [{ message: 'The Data Event function RECOGNIZETEXT() is not available for your current plan. Contact our sales team for more information.' }]);
  }
}
